import { z } from 'zod';

export const PERIODOS = ['hoje', '7d', 'mes', 'ano', 'personalizado'] as const;
export const periodoSchema = z
  .object({
    periodo: z.enum(PERIODOS).default('mes'),
    de: z.coerce.date().optional(),
    ate: z.coerce.date().optional(),
  })
  .refine((v) => v.periodo !== 'personalizado' || (v.de && v.ate && v.de <= v.ate), {
    message: 'Informe início e fim válidos',
  });
export type PeriodoInput = z.infer<typeof periodoSchema>;

const diaBr = new Intl.DateTimeFormat('en-CA', { timeZone: 'America/Sao_Paulo' });
/** Meia-noite de um dia (AAAA-MM-DD) em Brasília. Brasil sem horário de verão desde 2019. */
const meiaNoiteBr = (ymd: string) => new Date(`${ymd}T00:00:00.000-03:00`);
const DIA = 86_400_000;

/**
 * Converte um período em intervalo [de, ate] no calendário de Brasília, qualquer que seja o fuso
 * do servidor (no Docker é UTC: o mês começaria às 21h do dia anterior). `agora` injetável para testes.
 */
export function intervaloDoPeriodo(p: PeriodoInput, agora = new Date()): { de: Date; ate: Date } {
  const hoje = diaBr.format(agora);
  const inicioHoje = meiaNoiteBr(hoje);
  switch (p.periodo) {
    case 'hoje':
      return { de: inicioHoje, ate: agora };
    case '7d':
      return { de: new Date(inicioHoje.getTime() - 6 * DIA), ate: agora };
    case 'mes':
      return { de: meiaNoiteBr(`${hoje.slice(0, 7)}-01`), ate: agora };
    case 'ano':
      return { de: meiaNoiteBr(`${hoje.slice(0, 4)}-01-01`), ate: agora };
    case 'personalizado':
      // O painel manda instantes já no dia certo (00:00 e 23:59:59 locais do navegador)
      return { de: p.de ?? inicioHoje, ate: p.ate ?? agora };
  }
}
